import { render } from "./TourSection.vue?vue&type=template&id=79194996&scoped=true"
import script from "./TourSection.vue?vue&type=script&lang=js"
export * from "./TourSection.vue?vue&type=script&lang=js"

import "./TourSection.vue?vue&type=style&index=0&id=79194996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79194996"]])

export default __exports__